import { ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { Providers } from 'generated/graphql-types';
import { interval, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
   getProviderDisplayName,
   getProviders,
   providerSearch,
} from 'src/app/common-components/helpers/provider-helper';
import { EntityRegisterView } from 'src/app/common-components/register/models/register-view';
import { CallDetailsPrivileges } from 'src/app/pages/call-logs-register/models/call-details-privileges';
import { ActiveCallsOrderingOptions, ActiveCallsRegisterOptions } from '../../models/active-calls-register-options';
import { ActiveCallsRegisterListItem } from '../../models/active-calls-register-results.model';
import { HangUpCallsPrivileges } from '../../models/hang-up-calls.privileges';
import { toggleAutoRefresh } from '../../state/account-active-calls/account-active-calls.actions';
import { selectQuickFilters } from '../../state/account-active-calls/account-active-calls.reducer';

@Component({
   encapsulation: ViewEncapsulation.None,
   selector: 'ndt-account-active-calls-register-view',
   styleUrls: ['./account-active-calls-register-view.component.scss'],
   templateUrl: './account-active-calls-register-view.component.html',
   standalone: false,
})
export class AccountActiveCallsRegisterViewComponent extends EntityRegisterView<
   ActiveCallsRegisterListItem,
   ActiveCallsRegisterOptions,
   ActiveCallsOrderingOptions
> {
   protected selectQuickFilters(): (state: object) => ActiveCallsRegisterOptions | null {
      return selectQuickFilters;
   }
   @Input() hangupActiveCallsPrivileges: HangUpCallsPrivileges;

   @Input() callDetailsPrivileges: CallDetailsPrivileges;

   @Input() isSystemUser: boolean;

   @Output() openDialog = new EventEmitter<{ callLogs: any; callDetailId: number }>();

   @Output() hangupActiveCall = new EventEmitter<{ activeCall: ActiveCallsRegisterListItem }>();

   isAutoRefresh = true;

   providers = getProviders();

   selectedProvider: Providers | null;

   formatProvider = getProviderDisplayName;

   private minuteInterval: any;

   private destroyed$ = new Subject<void>();

   constructor(private cdRef: ChangeDetectorRef, public store: Store) {
      super(store);

      interval(1000)
         .pipe(takeUntil(this.destroyed$))
         .subscribe(() => {
            this.cdRef.markForCheck();
         });
   }

   ngOnInit() {
      this.startMinuteTimer();
   }

   onOpenDialog(callLogs: any) {
      this.openDialog.emit({ callLogs: callLogs, callDetailId: callLogs.callDetailId });
   }

   onHangupActiveCall(activeCall: ActiveCallsRegisterListItem) {
      this.hangupActiveCall.emit({ activeCall: activeCall });
   }

   providerFilterChange(provider: Providers | null) {
      this.registerOptions = {
         ...this.registerOptions,
         providerId: provider ?? undefined,
      };
      this.quickFilterChange.emit(this.registerOptions);
   }

   getRouterLink(id: number) {
      return '';
   }

   ngOnDestroy() {
      this.destroyed$.next();
      this.stopMinuteTimer();
   }

   providerDisplayWith(option: Providers): string {
      return `${option ?? ''}`;
   }

   providerSearch(searchText: string) {
      this.providers = providerSearch(searchText);
   }

   providerReset() {
      this.providers = getProviders();
   }

   autoRefreshToggleClicked(isToggled: boolean) {
      this.isAutoRefresh = isToggled;
      this.store.dispatch(toggleAutoRefresh({ isAutoRefresh: isToggled }));
   }

   private startMinuteTimer() {
      this.minuteInterval = setInterval(() => {
         this.cdRef.markForCheck();
      }, 60000);
   }

   private stopMinuteTimer() {
      if (this.minuteInterval) {
         clearInterval(this.minuteInterval);
      }
   }
}
